module.exports = __webpack_public_path__ + "img/icon20.a222d24b.png";